import React, { useState } from "react";
import { FiX } from "react-icons/fi";
import contactUs from "../../Asset/contactUs.svg";
import { ReactSVG } from "react-svg";
import { toast } from "react-toastify";
import ButtonLoading from "../ButtonLoading";

const ContactUs = ({ isOpen, setIsOpen }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [errors, setErrors] = useState({});

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const onClose = () => {
    setFormData({
      name: "",
      email: "",
      message: "",
    });
    setIsOpen(false);
  };

  const validate = () => {
    const errors = {};

    const name = (formData.name || "").trim();
    const email = (formData.email || "").trim();
    const message = (formData.message || "").trim();

    // Name
    if (!name) {
      errors.name = "Name is required";
    } else if (name.length < 3) {
      errors.name = "Name must be at least 3 characters";
    }

    // Email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!email) {
      errors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      errors.email = "Enter a valid email address";
    }

    // Message (≥ 20 words)
    if (!message) {
      errors.message = "Message is required";
    } else {
      const wordCount = message.split(/\s+/).filter(Boolean).length;
      if (wordCount < 10) {
        errors.message = `Message must be at least 10 words (currently ${wordCount}).`;
      }
    }
    setErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validate()) {
      setLoading(true);
      const data = {
        data: [
          {
            Last_Name: formData?.name,
            Email: formData?.email,
            Lead_Source: "Contact Us List",
            Description: formData?.message,
          },
        ],
      };
      let result;
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}proxy/zoho`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          }
        );
        result = await response.json();
        if (response.ok) {
          toast.success(
            `Thanks${
              formData.name ? `, ${formData.name}` : ""
            }! We’ve received your message and will reply at ${formData.email}.`,
            { toastId: "contactus-success" }
          );

          onClose();
        } else {
          // Only surface the server message on failure - otherwise a successful
          // submit showed both the success toast AND this info toast.
          const msg =
            result?.data?.[0]?.message ||
            result?.message ||
            (Array.isArray(result?.data) &&
              result.data
                .map((d) => d.message)
                .filter(Boolean)
                .join(", "));

          if (msg) {
            toast.info(msg, { toastId: "contactus-info" });
          }
        }
      } catch (err) {
        toast.error(`Couldn't send your message. ${err.message}`);
      } finally {
        setLoading(false);
      }
    }
  };

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-[#000000A3] backdrop-blur-[1px] z-[200]">
      <div className="bg-white relative  rounded-3xl mt-[2.5rem] max-h-[90vh]   md:max-w-md w-[90%] mx-auto p-4 font-inter flex flex-col gap-2">
        <div className=" md:w-20 w-16 md:h-20 h-16 absolute md:-top-[2.5rem] -top-[2rem] left-1/2 -translate-x-1/2 bg-white rounded-full flex items-center justify-center">
          <div className=" flex items-center justify-center md:w-16 w-12 md:h-16 h-12 bg-[#D7EFFC] rounded-full">
            <ReactSVG
              src={contactUs}
              beforeInjection={(svg) => {
                svg.setAttribute("class", "md:w-6 w-5 h-auto");
              }}
              className="w-auto"
            />
          </div>
        </div>
        <div className=" flex w-full items-center justify-end">
          <FiX onClick={onClose} className="  text-black cursor-pointer" />
        </div>
        <div className=" w-full text-center lg:text-[2.35rem] md:text-[2rem] text-[1.5rem] mt-4 font-bold  text-black">
          Contact Us
        </div>
        <p className=" text-center w-full text-[#00000099] md:text-base text-sm font-medium ">
          Have some feedback or a general question?
          <br className=" md:flex hidden" /> Get in touch with us below
        </p>
        <form
          className=" flex flex-col gap-4 max-h-[65vh] scrollbar-hide overflow-y-auto "
          onSubmit={handleSubmit}
        >
          <div className="flex flex-col gap-[2px]">
            <label htmlFor="" className=" md:text-base text-sm">
              Name
            </label>
            <input
              type="text"
              name="name"
              value={formData?.name}
              onChange={handleChangeInput}
              placeholder="Enter your name"
              className={` w-full bg-transparent outline-none border border-[#D7EFFC] md:p-3 p-2 rounded-full placeholder:text-[#00000033]`}
            />
            {errors?.name && (
              <p className="text-red-500 md:text-sm text-xs">{errors?.name}</p>
            )}
          </div>
          <div className="flex flex-col gap-[2px]">
            <label htmlFor="" className=" md:text-base text-sm">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData?.email}
              onChange={handleChangeInput}
              placeholder="hello@gmail.com"
              className=" w-full bg-transparent outline-none border border-[#D7EFFC] md:p-3 p-2 rounded-full placeholder:text-[#00000033]"
            />
            {errors?.email && (
              <p className="text-red-500 md:text-sm text-xs">{errors?.email}</p>
            )}
          </div>
          <div className="flex flex-col gap-[2px]">
            <label htmlFor="" className=" md:text-base text-sm">
              Message
            </label>
            <textarea
              name="message"
              value={formData?.message}
              onChange={handleChangeInput}
              rows={5}
              placeholder="Hey, I need help..."
              className=" w-full bg-transparent outline-none border border-[#D7EFFC] md:p-3 p-2 rounded-lg placeholder:text-[#00000033]"
            ></textarea>
            {errors?.message && (
              <p className="text-red-500 md:text-sm text-xs">
                {errors?.message}
              </p>
            )}
          </div>
          <button
            type="submit"
            disabled={loading}
            className={`${
              loading ? " opacity-50 cursor-not-allowed" : ""
            } text-white md:p-3 p-2.5 flex items-center justify-center w-full rounded-full bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] font-semibold text-[17px]`}
          >
            {loading ? <ButtonLoading text="Sending..." /> : "Send Message"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactUs;
